/**
 * Il CRM di piattaforma nella console: il percorso di un'azienda iscritta (registro delle azioni, 20/10/2026) e
 * l'elenco degli iscritti di un questionario. Gemello di `en.ts`.
 */
export default {
  percorso: {
    titolo: 'Percorso',
    prossimo_passo: 'Prossimo passo: {{passo}}',
    vuoto: 'Ancora nessuna voce. Il registro si riempie da solo a ogni passo con questa azienda.',
    errore: 'Il registro non si è caricato: {{errore}}',
    autore: {
      sistema: 'in automatico',
      skill: 'dalla skill',
      console: 'dalla console',
    },
    voce: {
      iscrizione: 'Si è iscritto',
      questionario_compilato: 'Ha compilato un questionario',
      email_conferma: 'Email di conferma',
      messaggio: 'Gli abbiamo scritto',
      risposta_ricevuta: 'Ci ha risposto',
      questionario_inviato: 'Gli abbiamo mandato un questionario',
      accesso_attivato: 'Accesso anticipato attivato',
      tetto_raggiunto: 'Ha raggiunto il limite giornaliero',
      proposta_pagamento: 'Proposto il piano a pagamento',
      passato_a_pagamento: 'È passato a pagamento',
      pausa_inattivita: 'Account in pausa per inattività',
      uscito: 'È uscito dalla lista',
      nota: 'Nota',
    },
    passo: {
      valutare_e_proporre: 'valutarlo e proporgli l’accesso anticipato',
      attendere_risposta: 'aspettiamo la sua risposta',
      rispondere: 'rispondergli',
      attendere_questionario: 'aspettiamo che compili il questionario',
      attivare_accesso: 'attivargli l’accesso anticipato',
      seguire_uso: 'seguire come lo usa',
      nessuno: 'niente da fare',
    },
  },
  iscritti: {
    cerca: 'Cerca',
    cerca_esempio: 'nome, azienda, email…',
    provenienza: 'Provenienza',
    tutte: 'Tutte',
    consenso: 'Consenso',
    tutti: 'Tutti',
    domanda: 'Domanda',
    nessun_filtro: 'Nessun filtro',
    ha_scelto: 'Ha scelto',
    qualsiasi: 'Qualsiasi',
    esporta: 'Esporta CSV ({{n}})',
    colonne: {
      data: 'Data',
      nome: 'Nome',
      ruolo: 'Ruolo',
      azienda: 'Azienda',
      email: 'Email',
      telefono: 'Telefono',
      a_che_punto: 'A che punto',
      provenienza: 'Provenienza',
      lingua: 'Lingua',
      consenso: 'Consenso',
      non_contattare: 'Non contattare',
    },
    apri_scheda: 'Apri la scheda',
    scheda_non_leggibile: 'La scheda di questa azienda non è leggibile',
    nessun_iscritto: 'Ancora nessun iscritto.',
    nessuno_coi_filtri: 'Nessun iscritto con questi filtri.',
    non_contattare_dal: 'Sì, dal {{data}}',
    non_contattare_compatto: 'Non contattare, dal {{data}}',
  },
} as const;
